import React, { useContext } from "react";
import clsx from "clsx";
import { createMuiTheme, makeStyles, ThemeProvider } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import Avatar from "@material-ui/core/Avatar";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import CallIcon from "@material-ui/icons/Call";
import { Image } from "semantic-ui-react";
import ArrowForwardIcon from "@material-ui/icons/ArrowForwardIosOutlined";
import ArrowBackIcon from "@material-ui/icons/ArrowBackIos";
import { green, red, blue } from "@material-ui/core/colors";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import DetailsIcon from "@material-ui/icons/Details";
import HistoryIcon from "@material-ui/icons/History";
import AssessmentIcon from "@material-ui/icons/Assessment";
import FolderSharedIcon from "@material-ui/icons/FolderShared";
import VolumeOffIcon from "@material-ui/icons/VolumeOff";
import VolumeUpIcon from "@material-ui/icons/VolumeUp";
import PhonePausedIcon from "@material-ui/icons/PhonePaused";
import PeopleIcon from "@material-ui/icons/People";
import CallMadeIcon from "@material-ui/icons/CallMade";
import "amazon-connect-streams";
import { getLogger } from "../services/LoggingService";
import ClearIcon from "@material-ui/icons/Clear";
import { SideMenu } from "./SideMenu";
import Tooltip from "@material-ui/core/Tooltip";
import { CallContext } from "../contexts/CallContext";
import ScreenPopContainer from "./ScreenPopContainer";
import { BuildTime } from "./base/BuildTime";
import { Ccp } from "./Ccp";
import Button from "@material-ui/core/Button";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import AppContext from "../contexts/AppContextProvider";
import { FormControlLabel, Switch } from "@material-ui/core";
const drawerWidth = 350;

const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        width: "100vw",
        padding: "0 0 0 0 !important",
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(["width", "margin"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        backgroundColor: "#F2F2F2",
    },
    logoutButton: {
        width: "200px",
    },
    logoContainer: {
        flexGrow: 1,
    },
    logo: {
        width: "280px",
    },
    avatar: {
        width: theme.spacing(4),
        height: theme.spacing(4),
    },
    green: {
        backgroundColor: green[500],
    },
    red: {
        backgroundColor: red[500],
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(["width", "margin"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    hide: {
        display: "none",
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: "nowrap",
    },
    drawerOpen: {
        width: drawerWidth,
        margin: "auto",
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    wrapperOpen: {
        width: "334px !important",
        height: "100% !important",
    },
    wrapperClosed: {
        height: "1px",
        width: "1px",
    },
    drawerClose: {
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: "hidden",
        width: theme.spacing(7) + 1,
        backgroundColor: "#4786A9",
    },
    toolbar: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        padding: theme.spacing(0, 1),
        backgroundColor: "#4786A9",
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
    },
    bottomLogout: {
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 500,
        zIndex: 500,
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        padding: theme.spacing(0, 1),
        backgroundColor: "#4786A9",
        ...theme.mixins.toolbar,
    },
    confirmDialog: {
        width: "300px",
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
    },
    my10: {
        marginTop: "10px",
        marginBottom: "10px",
    },
    ccpContainer: {
        display: "flex",
        height: "100% !important",
        justifyContent: "center",
        backgroundColor: "#4786A9",
    },
    whiteText: {
        color: "white",
    },
    screenpopContainer: {
        flex: 1,
        padding: "150 0 0 0 !important",
    },
}));
const theme = createMuiTheme({
    palette: {
        primary: {
            main: "#4786A9",
        },
        secondary: {
            main: green[500],
        },
    },
});

export default function CCPWrapper() {
    // const theme = useTheme()
    const classes = useStyles();

    const [hideWorkflow, setHideWorkflow] = React.useState(false);
    const [open, setOpen] = React.useState(true);
    const [initialized, setInitialized] = React.useState(false);
    const [incoming, setIncoming] = React.useState(false);
    const [connecting, setConnecting] = React.useState(false);
    const [connected, setConnected] = React.useState(false);
    const [sideMenuActiveIndex, setSideMenuActiveIndex] = React.useState(0);
    const [currentContact, setCurrentContact] = React.useState<connect.Contact | undefined>(undefined);
    const [currentAgent, setCurrentAgent] = React.useState<connect.Agent | undefined>({} as connect.Agent);
    const [muted, setMuted] = React.useState(false);
    const [onHold, setOnHold] = React.useState(false);
    const [contactDetails, setContactDetails] = React.useState({
        number: "",
    });
    const [dialogOpen, setDialogOpen] = React.useState(false);
    const context = useContext(AppContext);

    const { agent, contact } = useContext(CallContext);

    const logger = getLogger("CCPWrapper");

    React.useEffect(() => {
        if (!agent) {
            setCurrentAgent(undefined);
            setInitialized(false);
        } else {
            setCurrentAgent(agent);
            setInitialized(true);
            //callContext.setAgent(agent)
            agent.onMuteToggle((obj) => {
                setMuted(obj.muted);
            });
            agent.onStateChange((state) => {
                logger.debug("State changed ", state);
            });
        }
    }, [agent]);

    React.useEffect(() => {
        if (!contact) {
            setContactDetails({
                number: "",
            });
            setCurrentContact(undefined);
        } else {
            const number = contact.getActiveInitialConnection()?.getEndpoint().phoneNumber;
            setContactDetails({
                number: "" + number,
            });
            setCurrentContact(contact);

            contact.onConnected(() => {
                setConnected(true);
                setIncoming(false);
                setConnecting(false);
                context.setAlert("", "success");
            });
            contact.onIncoming(() => {
                setIncoming(true);

                context.setAlert(
                    contactDetails.number ? `Incoming call from ${contactDetails.number}` : "Incoming call ...",
                    "success"
                );
            });
            contact.onConnecting(() => {
                setConnecting(true);
            });
            contact.onPending((state) => {
                logger.debug("contact pending", state)
            });
            contact.onEnded(() => {
                setConnected(false);
                setConnecting(false);
                setIncoming(false);
            });
            contact.onRefresh(() => {
                setOnHold(contact.getAgentConnection().isOnHold());
            });
        }
    }, [contact]);
    const toggleMute = (newBool: boolean) => {
        logger.debug("Toggling mute from to ", muted, newBool);
        if (!currentAgent) return;
        if (newBool) {
            currentAgent.mute();
        } else {
            currentAgent.unmute();
        }
    };
    const toggleHold = (newBool: boolean) => {
        if (!currentContact) return;
        const onHold = currentContact.getAgentConnection().isOnHold();
        if (newBool && !onHold) {
            currentContact.getActiveInitialConnection()?.hold();
            setOnHold(true);
        } else if (!newBool && onHold) {
            currentContact.getActiveInitialConnection()?.resume();
            setOnHold(false);
        }
    };

    const handleIconClick = (type: string) => {
        if (type === "directory") {
            setSideMenuActiveIndex(0);
        } else if (type === "queue-outbound") {
            setSideMenuActiveIndex(1);
        } else if (type === "peer") {
            setSideMenuActiveIndex(2);
        } else if (type === "metrics") {
            setSideMenuActiveIndex(3);
        } else if (type === "details") {
            setSideMenuActiveIndex(4);
        } else if (type === "history") {
            setSideMenuActiveIndex(5);
        } else if (type === "answer") {
            if (currentContact) {
                currentContact.accept({
                    success: function () {
                        logger.debug("Connected Dude");
                    },
                    failure: function () {
                        logger.debug("Failed");
                    },
                });
            }
        } else if (type === "end") {
            if (currentContact) {
                currentContact.getActiveInitialConnection()?.destroy();
            }
        }
        setOpen(true);
    };
    const handleDialogOpen = () => {
        setDialogOpen(true);
    };

    const handleDialogClose = () => {
        setDialogOpen(false);
    };
    const handleSignout = () => {
        var state = agent?.getAgentStates().filter((s) => s.name === "Offline")[0];
        if (state) {
            agent?.setState(state, {
                success: () => {
                    setDialogOpen(false);
                    logout();
                },
                failure: () => logger.debug("Could not sign Agent out"),
            });
        } else {
            setDialogOpen(false);
            logout();
        }
    };
    const logout = () => {
        setTimeout(() => {
            window.close();
        }, 500);
        window.location.href = `${context.config.connectUrl}/logout`;
    };
    return (
        <ThemeProvider theme={theme}>
            <div className={classes.root}>
                <AppBar
                    position="fixed"
                    className={clsx(classes.appBar, {
                        [classes.appBarShift]: open,
                    })}
                >
                    <Toolbar>
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            onClick={() => setOpen(true)}
                            edge="start"
                            className={clsx(classes.menuButton, {
                                [classes.hide]: open,
                            })}
                        >
                            <ArrowForwardIcon style={{ color: "#4786A9" }} />
                        </IconButton>
                        <div className={classes.logoContainer}>
                            <div className={classes.logo}>
                                <Image src="top-logo.png" />
                            </div>
                        </div>
                        <div>
                            <FormControlLabel
                                style={{ marginRight: "25px", color: "black" }}
                                aria-label="Enable"
                                onClick={(event) => event.stopPropagation()}
                                onFocus={(event) => event.stopPropagation()}
                                control={
                                    <Switch
                                        color="primary"
                                        onChange={() => setHideWorkflow(!hideWorkflow)}
                                        checked={hideWorkflow}
                                    />
                                }
                                labelPlacement="start"
                                label="Hide workflow"
                            />
                        </div>
                        {initialized && (
                            <Button
                                disabled={connected || connecting || incoming}
                                variant="contained"
                                color="primary"
                                size="large"
                                className={classes.logoutButton}
                                endIcon={<ExitToAppIcon />}
                                onClick={handleDialogOpen}
                            >
                                logout
                            </Button>
                        )}
                    </Toolbar>
                </AppBar>
                <Drawer
                    variant="permanent"
                    className={clsx(classes.drawer, {
                        [classes.drawerOpen]: open,
                        [classes.drawerClose]: !open,
                        "hide-scrollbar": true,
                    })}
                    classes={{
                        paper: clsx({
                            [classes.drawerOpen]: open,
                            [classes.drawerClose]: !open,
                        }),
                    }}
                >
                    <div className={classes.toolbar}>
                        <IconButton className={clsx(classes.whiteText)} onClick={() => setOpen(false)}>
                            <ArrowBackIcon style={{ color: "white" }} />
                        </IconButton>
                    </div>
                    <Divider />
                    {!open && (
                        <List>
                            {(connecting || incoming) && (
                                <ListItem button onClick={() => handleIconClick("answer")}>
                                    <ListItemAvatar>
                                        <Tooltip title="Answer call" placement="right">
                                            <Avatar className={clsx(classes.avatar, classes.green)}>
                                                <CallIcon style={{ color: "white" }} />
                                            </Avatar>
                                        </Tooltip>
                                    </ListItemAvatar>
                                </ListItem>
                            )}
                            {connected && (
                                <ListItem button onClick={() => handleIconClick("end")}>
                                    <ListItemAvatar>
                                        <Tooltip title="End call" placement="right">
                                            <Avatar className={clsx(classes.avatar, classes.red)}>
                                                <ClearIcon style={{ color: "white" }} />
                                            </Avatar>
                                        </Tooltip>
                                    </ListItemAvatar>
                                </ListItem>
                            )}
                            {connected && (
                                <ListItem button onClick={() => toggleMute(!muted)}>
                                    <ListItemAvatar>
                                        {muted ? (
                                            <Tooltip title="Unmute call" placement="right">
                                                <Avatar className={clsx(classes.avatar, classes.green)}>
                                                    <VolumeUpIcon style={{ color: "white" }} />
                                                </Avatar>
                                            </Tooltip>
                                        ) : (
                                            <Tooltip title="Mute call" placement="right">
                                                <Avatar className={clsx(classes.avatar, classes.red)}>
                                                    <VolumeOffIcon style={{ color: "white" }} />
                                                </Avatar>
                                            </Tooltip>
                                        )}
                                    </ListItemAvatar>
                                </ListItem>
                            )}
                            {connected && (
                                <ListItem button onClick={() => toggleHold(!onHold)}>
                                    <ListItemAvatar>
                                        {onHold ? (
                                            <Tooltip title="Resume call" placement="right">
                                                <Avatar className={clsx(classes.avatar, classes.green)}>
                                                    <CallIcon style={{ color: "white" }} />
                                                </Avatar>
                                            </Tooltip>
                                        ) : (
                                            <Tooltip title="Place call on hold" placement="right">
                                                <Avatar className={clsx(classes.avatar, classes.red)}>
                                                    <PhonePausedIcon style={{ color: "white" }} />
                                                </Avatar>
                                            </Tooltip>
                                        )}
                                    </ListItemAvatar>
                                </ListItem>
                            )}
                            {!(connecting || incoming) && !connected && (
                                <ListItem button onClick={() => handleIconClick("details")}>
                                    <ListItemIcon>
                                        <Tooltip title="Open CCP" placement="right">
                                            <CallIcon style={{ color: "white" }} />
                                        </Tooltip>
                                    </ListItemIcon>
                                </ListItem>
                            )}
                            <Divider className={classes.my10} />
                            <ListItem button onClick={() => handleIconClick("directory")}>
                                <ListItemIcon>
                                    <Tooltip title="Open Directory" placement="right">
                                        <FolderSharedIcon style={{ color: "white" }} />
                                    </Tooltip>
                                </ListItemIcon>
                            </ListItem>
                            <ListItem button onClick={() => handleIconClick("queue-outbound")}>
                                <ListItemIcon>
                                    <Tooltip title="Custom Queue Outbound call" placement="right">
                                        <CallMadeIcon style={{ color: "white" }} />
                                    </Tooltip>
                                </ListItemIcon>
                            </ListItem>
                            <ListItem button onClick={() => handleIconClick("peer")}>
                                <ListItemIcon>
                                    <Tooltip title="Open Peer Status" placement="right">
                                        <PeopleIcon style={{ color: "white" }} />
                                    </Tooltip>
                                </ListItemIcon>
                            </ListItem>
                            <ListItem button onClick={() => handleIconClick("metrics")}>
                                <ListItemIcon>
                                    <Tooltip title="Open Metrics" placement="right">
                                        <AssessmentIcon style={{ color: "white" }} />
                                    </Tooltip>
                                </ListItemIcon>
                            </ListItem>
                            <ListItem button onClick={() => handleIconClick("details")}>
                                <ListItemIcon>
                                    <Tooltip title="Open Call Details" placement="right">
                                        <DetailsIcon style={{ color: "white" }} />
                                    </Tooltip>
                                </ListItemIcon>
                            </ListItem>

                            <ListItem button onClick={() => handleIconClick("history")}>
                                <ListItemIcon>
                                    <Tooltip title="Open History" placement="right">
                                        <HistoryIcon style={{ color: "white" }} />
                                    </Tooltip>
                                </ListItemIcon>
                            </ListItem>
                        </List>
                    )}

                    <div className={clsx(classes.ccpContainer)}>
                        <div
                            className={clsx({
                                [classes.wrapperOpen]: open,
                                [classes.wrapperClosed]: !open,
                            })}
                        >
                            <Ccp ccpVisible={open} onInitialized={() => setInitialized(true)} />
                            {initialized && open && <SideMenu activeIndex={sideMenuActiveIndex} />}
                        </div>
                    </div>
                </Drawer>
                <ScreenPopContainer drawerOpen={open} hideWorkflow={hideWorkflow} />
                <BuildTime />
                <Dialog
                    open={dialogOpen}
                    onClose={handleDialogClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle className={classes.confirmDialog} id="alert-dialog-title">
                        {"Signing out?"}
                    </DialogTitle>
                    <DialogContent></DialogContent>
                    <DialogActions>
                        <Button onClick={handleDialogClose} color="primary">
                            cancel
                        </Button>
                        <Button onClick={handleSignout} color="primary">
                            sign out
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        </ThemeProvider>
    );
}
